import { where, writeBatch } from 'firebase/firestore'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths'
import React, { useCallback, useContext, useState } from 'react'
import { seasonalHelpers } from '../cnr/reducers/reducerHelpers/seasonalHelpers'
import { useSeasonalData } from './useSeasonals'
import { _cacheGroupTypes } from 'global/cnr/contexts/useHelpers/useTimestamp'

const _allowUpdates = true

export const useSports = () => {

  const parentContext = useContext(ParentContext)
  const { fns, states } = parentContext ?? {}
  const { appUser_state, app_state, paps_state } = states ?? {}
  const { mainDb } = app_state ?? {}
  const { appUser } = appUser_state ?? {}
  const { pathViews } = paps_state ?? {}
  const { database_fns } = fns

  const { getSports_collectionItem } = useSeasonalData()
  const [updating, setUpdating] = useState()

  const get_sports = useCallback(async ({ callback }) => {
    setUpdating(true)
    try {
      const cb = (results) => { callback(results) }
      const _refPath_sports = createRefPath_event(pathViews, ['sports'])
      const wheres = []
      wheres.push(where('parentKeys.organizations', '==', pathViews.organizations))
      wheres.push(where('parentKeys.districts', '==', pathViews.districts))
      database_fns.get_data({ refPath: _refPath_sports, callback: cb, wheres })
    } catch (err) {
      console.error('get_sports error', err)
    } finally {
      setUpdating(false)
    }
  }, [])

  const update_selectedSeason = useCallback(async ({ sportsKey, selectedYear }) => {
    setUpdating(true)
    const batch = writeBatch(mainDb);
    const dataToUpdate = { latestSeason: selectedYear }

    // update SPORTS
    const _refPath_sports_global = createRefPath_event(pathViews, ['sports', sportsKey])
    console.log('_refPath_sports', _refPath_sports_global, dataToUpdate)
    await database_fns.update_doc(_refPath_sports_global, dataToUpdate, null, batch)

    // update _SPORTS
    const _pks = seasonalHelpers.getPks(pathViews, null, null, ['sports', 'teams', 'schools'])
    const _sportsYearCollectionItem = await getSports_collectionItem(_pks, '_sports', true)

    if (_sportsYearCollectionItem) {
      const { _itemKey } = _sportsYearCollectionItem
      const dataToUpdate2 = {}
      dataToUpdate2[`sports.${sportsKey}.latestSeason`] = selectedYear
      const refPath_sports_pks = createRefPath_event(pathViews, ['_sports', _itemKey])
      database_fns.update_doc(refPath_sports_pks, dataToUpdate2, null, batch);
      console.log('refPath_sports2', refPath_sports_pks, dataToUpdate2)
      if (_allowUpdates) {
        const _timestamp = Date.now()
        database_fns.update_timestamp('districtsInfo', pathViews.districts, _timestamp, batch)
        await batch.commit();
        setUpdating(false)
      } else {
        setUpdating(false)
      }
    }

    setUpdating()
  }, [])

  return { update_selectedSeason, get_sports, updating }
}


